import { COLORS } from '../IndividualPlan/tokens';

export const BENCH = {
  ink: COLORS.ink,
  muted: COLORS.muted,
  zero: '#7F7F99',
  surface: COLORS.bg,
  cardBg: '#FFFFFF',
  divider: COLORS.divider,
  headerRule: COLORS.ink,
  action: COLORS.navy,
  hot: '#B20101',
  status: {
    scored: '#2A2A8B',
    toScore: '#A9A9E5',
    inProgress: '#F6A55B',
    notStarted: '#FE5858',
  },
  tile: { fill: '#6262D0', track: '#C1C1CD' },
  switcherBg: COLORS.bg,
  font: '"Nunito Sans", "Helvetica", "Arial", sans-serif',
  cardShadow:
    '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)',
} as const;
